import React from 'react'
import styled from '@emotion/styled'
import { Input, Select, Space } from 'antd'
import { PortalCoursesConfig } from '../../../models/PortalArtigoModel'
import { createDefaultCourses } from '../helpers/artigo-defaults'
import { useSiteCourseOptions } from '../helpers/use-portal-editor-reference-options'
import { PortalEditorField } from './PortalEditorField'

interface CoursesEditorProps {
  value?: PortalCoursesConfig
  onChange: (value: PortalCoursesConfig) => void
}

export function CoursesEditor({
  value,
  onChange,
}: CoursesEditorProps) {
  const courses = value || createDefaultCourses()
  const selectedCourseIds = courses.courseIds || []
  const { courseOptions, loadingCursos } = useSiteCourseOptions(selectedCourseIds)

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <PortalEditorField label="Título da seção de cursos">
        <Input
          value={courses.title}
          placeholder="Título"
          onChange={(event) => onChange({ ...courses, title: event.target.value })}
        />
      </PortalEditorField>
      <PortalEditorField label="Cursos relacionados">
        <Select
          mode="multiple"
          allowClear
          showSearch
          loading={loadingCursos}
          optionFilterProp="label"
          maxTagCount="responsive"
          value={selectedCourseIds}
          options={courseOptions}
          placeholder="Selecione os cursos relacionados"
          style={{ width: '100%' }}
          onChange={(courseIds: number[]) => onChange({ ...courses, courseIds })}
        />
      </PortalEditorField>
      <AdvancedFields>
        <summary>Configurações avançadas</summary>
        {selectedCourseIds.length > 0 ? (
          <ReadOnlyHelper>IDs selecionados: {selectedCourseIds.join(', ')}</ReadOnlyHelper>
        ) : null}
        <PortalEditorField label="ID da âncora dos cursos">
          <Input
            value={courses.anchorId}
            placeholder="ID da âncora"
            onChange={(event) => onChange({ ...courses, anchorId: event.target.value })}
          />
        </PortalEditorField>
      </AdvancedFields>
    </Space>
  )
}

const AdvancedFields = styled.details`
  width: 100%;
  color: #595959;

  summary {
    cursor: pointer;
    color: #595959;
    font-weight: 600;
    margin-bottom: 8px;
  }
`

const ReadOnlyHelper = styled.div`
  margin-bottom: 8px;
  color: #8c8c8c;
  font-size: 12px;
`
